import { Helmet } from 'react-helmet-async';

interface CreativeWorkSchemaProps {
  headline: string;
  description: string;
  image?: string;
  datePublished?: string;
  dateModified?: string;
  author?: string;
  url?: string;
}

export const CreativeWorkSchema = ({
  headline,
  description,
  image,
  datePublished,
  dateModified,
  author = "Fortify",
  url
}: CreativeWorkSchemaProps) => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "CreativeWork",
    "headline": headline,
    "description": description,
    "image": image,
    "datePublished": datePublished,
    "dateModified": dateModified || datePublished,
    "author": {
      "@type": "Organization",
      "name": author
    },
    "publisher": {
      "@type": "Organization",
      "name": "Fortify",
      "logo": {
        "@type": "ImageObject",
        "url": "https://fortify.dev/logo.png"
      }
    },
    "url": url
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};
